import { BaseTheme } from '../BaseTheme';
import { IToggleButtonStyles } from './IToggleButtonStyles';

export class CometThemeToggleButtonStyles implements IToggleButtonStyles {
    private baseToggleButtonRootStyle;
    constructor(
        private theme: BaseTheme,
        private height: number,
        private toggleButtonWidth: number,
        private darkPrimaryAlt: string,
        private lightPrimary: string,
        private lightPrimaryAlt: string
    ) {
        this.baseToggleButtonRootStyle = {
            height: this.height,
            minWidth: this.toggleButtonWidth,
            maxWidth: '100%',
            padding: '0 4px',
        };
    }

    get lightOpen() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
                color: this.theme.semanticColors.bodyText,
                background: this.lightPrimary,
            },
            rootHovered: {
                color: this.theme.semanticColors.bodyText,
                background: this.lightPrimaryAlt,
            },
        };
    }
    get lightClose() {
        return {
            root: {
                border: 'none',
                ...this.baseToggleButtonRootStyle,
                color: 'unset',
            },
        };
    }
    get darkOpen() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
                color: this.theme.semanticColors.bodyText,
                background: this.lightPrimary,
            },
            rootHovered: {
                background: this.lightPrimaryAlt,
            },
        };
    }
    get darkClose() {
        return {
            root: {
                ...this.baseToggleButtonRootStyle,
                border: 'unset',
                backgroundColor: 'unset',
            },
            rootPressed: {
                borderColor: this.darkPrimaryAlt,
                backgroundColor: this.darkPrimaryAlt,
            },
            rootHovered: {
                borderColor: this.darkPrimaryAlt,
                backgroundColor: this.darkPrimaryAlt,
            },
        };
    }
}
